"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinishCsvResponse = exports.UniqueId_Error = exports.UniqueId_EOF = void 0;
exports.UniqueId_EOF = "EOF";
exports.UniqueId_Error = "ERROR";
exports.FinishCsvResponse = {
    uniqueId: exports.UniqueId_EOF,
    results: [],
};
